import { createDeepEqualSelector } from './index';
import { SearchGlobalStateType, SearchSliceState } from '../../types';
import { getRandomNumber } from '../../utils/helpers';
import { initialSearchState } from '../sliceCreators/searchSlice';

export const searchSelector = (
  state: SearchGlobalStateType,
): SearchSliceState => state.search;

export const searchResultsSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search?.results ?? [],
);

export const searchPaginationSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search?.pagination || initialSearchState.pagination,
);

export const searchOptionsSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.searchOptions,
);

export const isSearchingSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.isSearching,
);

export const xRequestIdSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.xRequestId || '',
);

export const xSessionIdSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.xSessionId || '',
);

export const materialsInQueueSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.materialsInQueue || [],
);

export const campaignBannersSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.campaignBanners || [],
);

export const campaignTopBannerSelector = createDeepEqualSelector(
  campaignBannersSelector,
  (banner) => banner?.find((item) => item.position === 'header'),
);

export const campaignContentBannerSelector = createDeepEqualSelector(
  campaignBannersSelector,
  (banners) => {
    const list = banners?.filter((item) => item.position === 'content');
    const randomIndex = getRandomNumber(list?.length);
    return list?.[randomIndex];
  },
);

export const campaignFooterBannerSelector = createDeepEqualSelector(
  campaignBannersSelector,
  (banner) => banner?.find((item) => item.position === 'footer'),
);

export const isSearchQueryRelaxedSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.isSearchQueryRelaxed,
);

export const isSearchRedirectSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.isSearchRedirect,
);

export const collectionHeaderSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.collectionHeader,
);

export const selectedVariantsSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.selectedVariants,
);

export const stripMaterialsSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.stripMaterials,
);

export const isStripMaterialsLoadingSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.isStripMaterialsLoading,
);

export const contentBlocksSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.contentBlocks || [],
);

export const contentBlockXRequestIdSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.contentBlockXRequestId,
);

export const productWithFilePreviewInQueueSelector = createDeepEqualSelector(
  searchSelector,
  (search) => search.productWithFilePreviewInQueue,
);
